import { Building2, Pill, ShoppingCart, UtensilsCrossed, type LucideIcon } from 'lucide-react';
import type { BusinessCategoryCode } from '@quds/shared';

export const CATEGORY_ICONS: Record<BusinessCategoryCode, LucideIcon> = {
  PHARMACY: Pill,
  SUPERMARKET: ShoppingCart,
  RESTAURANT: UtensilsCrossed,
  OTHER: Building2,
};
